import API from "../../classes/Api/Api";
import URL from "../../classes/Url/URL";
import Response from "../../classes/Response/Response";
import Session from "../../classes/Session/Session";
import CustomError from "../../classes/CustomError/CustomError";
import Storage from "../../classes/Storage/Storage";

const MFAService = () => {
  const verify = async (mfaData) => {
    const api = new API(`${URL.URL_SERVER}/mfa`, {
      validateStatus: (status) => status === 200,
    });
    const http_response = await api.post(mfaData);
    const has_error = http_response instanceof CustomError;
    if (has_error) {
      return http_response;
    }
    const response = new Response(http_response, Session);
    const data = response.wasSuccessfull().single();
    data.saveInStorage();
    return data;
  };

  const resend = async (mfaData) => {
    const api = new API(`${URL.URL_SERVER}/mfa`, {
      validateStatus: (status) => status === 200,
    });
    const http_response = await api.put(mfaData);
    const has_error = http_response instanceof CustomError;
    if (has_error) {
      return http_response;
    }
    const newSession = http_response && http_response.data && http_response.data.session;
    if (newSession) {
      return { success: true, session: newSession };
    }
    return { success: true };
  };

  const createSession = async (data) => {
    const api = new API(`${URL.URL_SERVER}/sessions`);
    const http_response = await api.post(data);
    const has_error = http_response instanceof CustomError;
    if (!has_error) {
      const response = new Response(http_response, Session);
      const data = response.wasSuccessfull().single();
      const storage = new Storage("id_session", data.id);
      storage.setItem();
    } else {
      return http_response;
    }
  };

  return {
    verify,
    resend,
    createSession,
  };
};

export default MFAService;
